import { SymbolEventColumn } from 'widgets/corpActions/widget/grid/columnDefinitions';
import { GridDetailsPanelColumnDef } from 'utils/components/GridDetailsPanel/gridDetailsPanelColumnDef';

const divestiture: GridDetailsPanelColumnDef<SymbolEventColumn>[] = [
    {
        controls: [
            { type: 'field', field: 'adUnit' },
            { type: 'field', field: 'adAcquiredBy' },
            { type: 'field', field: 'adAmt' },
            { type: 'field', field: 'adType' },
            { type: 'field', field: 'adCash' },
            { type: 'field', field: 'adCashFlag' },
            { type: 'field', field: 'exDate' },
        ],
    },
    {
        controls: [
            { type: 'field', field: 'adShares' },
            { type: 'field', field: 'adSharesFlag' },
            { type: 'field', field: 'adStat' },
            { type: 'field', field: 'adCurrency' },
            { type: 'field', field: 'adAcquirerTicker' },
            { type: 'field', field: 'adTargetTicker' },
        ],
    },
];

export default divestiture;
